export default __webpack_public_path__ + "static/media/Michael_Jackson_0002.efac34ee.jpg";